import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type UploadMediaStatusQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  uploadId: Types.Scalars['ID'];
}>;

export type UploadMediaStatusQuery = {
  __typename?: 'Query';
  uploadMediaStatus: {
    __typename?: 'MediaUploadCollection';
    id?: string | null;
    uploadId: string;
    name?: string | null;
    status: Types.UploadStatus;
    attemptInMs: number;
    uploads: Array<{
      __typename?: 'MediaUpload';
      id?: string | null;
      assetId: string;
      status: Types.MediaStatus;
      photo?: { __typename?: 'MediaUploadPhoto'; id: string; url: string; height: number; width: number } | null;
    }>;
  };
};

export const UploadMediaStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UploadMediaStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadMediaStatus' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'uploadId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'uploadId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attemptInMs' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uploads' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'assetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useUploadMediaStatusQuery__
 *
 * To run a query within a React component, call `useUploadMediaStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadMediaStatusQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      uploadId: // value for 'uploadId'
 *   },
 * });
 */
export function useUploadMediaStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>) {
  return ApolloReactHooks.useQuery<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>(UploadMediaStatusDocument, baseOptions);
}
export function useUploadMediaStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>(UploadMediaStatusDocument, baseOptions);
}
export type UploadMediaStatusQueryHookResult = ReturnType<typeof useUploadMediaStatusQuery>;
export type UploadMediaStatusLazyQueryHookResult = ReturnType<typeof useUploadMediaStatusLazyQuery>;
export type UploadMediaStatusQueryResult = Apollo.QueryResult<UploadMediaStatusQuery, UploadMediaStatusQueryVariables>;
